import axios from "axios";

import { getConfig } from "~/config";
import { AuthApiError, RefreshFailedError } from "./errors";

export type RefreshSessionRequest = {
  refreshToken: string;
};

export type RefreshSessionResponse = {
  accessToken: string;
  accessTokenExpiresAt: number;
  refreshToken: string;
  refreshTokenExpiresAt: number;
};

const endpointUrl = (): string =>
  new URL(
    "api/kontax/accounts/api/sessions/refresh",
    getConfig("VITE_APP_API_URL")
  ).toString();

export const refreshSession = async (
  request: RefreshSessionRequest
): Promise<RefreshSessionResponse> => {
  try {
    const response = await axios.post<RefreshSessionResponse>(
      endpointUrl(),
      { refreshToken: request.refreshToken },
      {
        headers: { "Content-Type": "application/json" },
        validateStatus: (status) => status === 200,
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status ?? null;
      const upstreamMessage = error.response?.data?.message;
      if (status !== null && status >= 400 && status < 500) {
        throw new RefreshFailedError(status, upstreamMessage);
      }
      throw new AuthApiError(
        `Failed to refresh session${
          upstreamMessage ? `: ${upstreamMessage}` : ""
        }`,
        { status, upstreamMessage }
      );
    }
    throw error;
  }
};
